import st from "@/styles/Ui.module.scss";
import clsx from "clsx";
import StaticRangeSlider from "@/ui/StaticRangeSlider.tsx";
import React from "react";
import StepsInterface from "@/types_and_interfaces/sidebar_steps_interface.ts";
import {useParams} from "react-router-dom";

interface Props {
    steps:Array<StepsInterface>
}

const HeaderSteps:React.FC<Props> = ({steps}) => {
    const {step} = useParams()
    
    const transparent_bg = "rgba(255, 255, 255, 0.20)"
    const orange = "#ea7c15"
    
    return (
        <div className={st.confirm_ident_steps}>
            
            {steps.map((stp:StepsInterface, i:number) => {
                
                return (
                    <div key={`header_steps_${i}`} className={clsx(st.sides)}>
                        <StaticRangeSlider
                            max={1}
                            value={(step === String(i + 1) || Number(step) > (i + 1)) ? 1 : 0}
                            denyValueLabel
                            secondary
                            height={8}
                            railColor={transparent_bg}
                            no_value_display
                        />
                        
                        <div style={{background: (step === String(i + 1) || Number(step) > (i + 1)) ? orange : transparent_bg}} className={st.icon}>
                            {stp.icon}
                        </div>
                    
                    </div>
                )
            })}
            
        </div>
    )
}

export default HeaderSteps
